const client = {
    subPath: '',
    head: {
        title: 'Zip for Vend POS',
        meta: [
            {
                charset: 'utf-8'
            },
            {
                name: 'keywords',
                content: 'zip, payment, vend, pos'
            },
            {
                name: 'description',
                content: 'Zip for Vend POS'
            }
        ],
        link: [
            {
                rel: 'icon',
                type: 'image/png',
                href: 'https://zip.co/assets/zip/favicons/180x180.png'
            }
        ]
    },
    views: {
        delayBeforeReturn: 500,
        pairing: {
            title: 'Connect Zip now',
            vendLogo: 'https://d30fzr2520l6g5.cloudfront.net/corp-images-optimised/homepage/vend-tag-logo.svg',
            zipLogo: 'https://zip.co/assets/zip/logos/zip/primary.svg',
            defaultMessage: `Welcome! Let's set up {env}Zip on your Vend POS`,
            invalidPurchaseMessage: 'Request invalid. Please access this page through your Vend terminal.'
        },
        purchase: {
            title: 'Purchase',
            logo: 'https://zip.co/assets/zip/logos/zip/primary.svg',
            defaultMessage: 'Please wait, processing your purchase...',
            receiptHtml: '<p>Thank you for purchasing with Zip. <br/>Receipt #: {receipt_number}</p>',
            successMessage: 'Congratulation! You have successfully placed your order.',
            timeoutErrorMessage: 'Confirmation timeout',
            expiredErrorMessage: 'Your purchase has expired',
            waitingMessage: 'Waiting for response...',
            exceptionMessage: 'Something went wrong while processing your purchase',
            missingCardDetailsErrorMessage: 'Unable to retrieve cart details from Vend',
            transactionStatusMessage: 'Your purchase has been {status}',
            delay: 2000,
            timeout: 60000
        },
        refund: {
            title: 'Refund',
            logo: 'https://zip.co/assets/zip/logos/zip/primary.svg',
            defaultMessage: 'Please wait...',
            receiptHtml: '<p>Thank you for refunding with Zip.</p>',
            successMessage: 'You have successfully refunded your purchase.',
            exceptionMessage: 'Something went wrong while processing your refund',
            unableRefundErrorMessage:
                'Unable to process refund through this app. Please access Vend through a web browser to refund the Zip transaction.'
        }
    }
};

export default client;
